<script setup lang="ts">
import '@/assets/scss/form.scss'
import { useToast } from 'primevue/usetoast'
import { computed, onMounted, ref, watch } from 'vue'
import { uuid } from 'vue3-uuid'
import moment from 'moment'
import AccountPicker from '@/onenetwork/components/account_picker/AccountPicker.vue'
import { Icon } from '@iconify/vue'
import './../assets/scss/contract.scss'
import AttachmentList from '@/onenetwork/components/attachment_list/AttachmentList.vue'
import TimeLinePicker from '@/onenetwork/components/timeline_picker/TimeLinePicker.vue'
import { ContractDetailActionType, useContractDetailStore } from '@/modules/contract/stores/contract.detail.store.ts'
import DateTimeFormated from '@/onenetwork/components/datetime/DateTimeFormated.vue'
import CommissionAmount from '@/modules/contract/components/parts/CommissionAmount.vue'
import MoneyAmount from '@/modules/contract/components/parts/MoneyAmount.vue'
import PercentAmount from '@/modules/contract/components/parts/PercentAmount.vue'
import { CONTRACT_STATES } from '@/modules/contract/constants/contract.constant.ts'


interface Props {
  contractId: number | null
}

const props = defineProps<Props>()
const toast = useToast()
const contractDetailStore = useContractDetailStore()


const timelineDataSet = ref<any>([])

const timelineValue = ref('')

const handleTimelineChange = (item: any, dataSet: any) => {
  timelineValue.value = item.id
  timelineDataSet.value = dataSet
}

const handleShowDetail = () => {

}

const handleShowSellerDetail = ()=>{

}

const setTimeLineData = (data: any) => {
  const _dataSet = timelineDataSet.value
  if( _dataSet && _dataSet.length > 0 ){
    let done = false;
    _dataSet.forEach((_item: any) => {
      if(!done){
        if(_item.id == data.status){
          done = true;
          _item.done = true;
        }else{
          _item.done = true;
        }
      } else{
        _item.done = false;
      }
    })
  }

  timelineDataSet.value = _dataSet
}

const contractDetail = computed(() => {
  return contractDetailStore.contracts[props.contractId] || null
})

const fetchDetail = async () => {
  try{
    const data = await contractDetailStore.fetchDetail(props.contractId)
    setTimeLineData(data)
  } catch (e: any) {
    console.error(e)
    toast.add({severity: 'error', summary: 'Lỗi!', detail: "Lỗi khi tải thông tin"})
  }
}

onMounted(() => {
  timelineDataSet.value = CONTRACT_STATES.map((state: any) => ({...state, done: false}))
  // if(!contractDetail.value)
    fetchDetail()
})
</script>

<template>
  <div class="py-3 flex flex-col gap-5" v-if="contractDetail?.action_type == ContractDetailActionType.FETCHED">

    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Loại hợp đồng</th>
        <td colspan="3">
          <div class="flex-1 font-bold uppercase">
            {{contractDetail.contract.type}}
          </div>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Mã hợp đồng</th>
        <td colspan="3">
          <tag severity="info">{{contractDetail.contract.code}}</tag>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiêu đề hợp đồng</th>
        <td colspan="3">
          <div class="flex-1 font-bold capitalize">
            <div class="text-xl">{{contractDetail.contract.title}}</div>
            {{contractDetail.contract.subtitle}}
          </div>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Đính kèm</th>
        <td colspan="3">
          <AttachmentList :data="contractDetail.contract.attachments" :editable="false" @remove="handleFileRemove"/>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Ngày ký</th>
        <td>
          <date-time-formated :value="contractDetail.contract.signed_at"/>
        </td>
        <th class="text-right w-[150px]">Ngày thanh lý</th>
        <td>
          <date-time-formated :value="contractDetail.contract.liquidated_at"/>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiến độ hợp đồng</th>
        <td colspan="3">
          <time-line-picker
            :dataSet="timelineDataSet"
            :value="timelineValue"
            :editable="false"
            @update="handleTimelineChange"/>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Chính chủ</th>
        <td>
          <div class="contract-ref-panel">
            <div class="subject">{{contractDetail.contract?.seller?.full_name}}</div>
            <div class="desc">
              <div class="key-val-row"><span class="key">CCCD:</span><span class="value">{{contractDetail.contract?.seller?.kyc_information?.national_id_number}}</span></div>
              <div class="key-val-row"><span class="key">Địa chỉ:</span><span class="value">{{contractDetail.contract?.seller?.kyc_information?.full_address}}</span></div>
              <div class="key-val-row"><span class="key">SDT:</span><span class="value">{{contractDetail.contract?.seller?.phone_number}}</span></div>
              <div class="key-val-row"><span class="key">Email:</span><span class="value">{{contractDetail.contract?.seller?.email}}</span></div>
              <div class="key-val-row"><span class="key">Mã số thuế:</span><span class="value">{{contractDetail.contract?.seller?.customer_profile?.tax_id}}</span></div>
              <div class="key-val-row"><span class="key">Ngân hàng:</span><span class="value">
                {{contractDetail.contract?.seller?.customer_profile?.bank_info}}
              </span></div>
            </div>
            <div class="detail-btn" @click="handleShowSellerDetail"><Icon icon="bi:info-circle-fill" /> chi tiết</div>
          </div>
        </td>
        <th class="text-right w-[150px]">Môi giới bán</th>
        <td>
          <div class="contract-ref-panel">
            <div class="subject">{{contractDetail.contract?.seller_broker?.full_name}}</div>
            <div class="desc">
              <div class="key-val-row"><span class="key">CCCD:</span><span class="value">{{contractDetail.contract?.seller_broker?.kyc_information?.national_id_number}}</span></div>
              <div class="key-val-row"><span class="key">Địa chỉ:</span><span class="value">{{contractDetail.contract?.seller_broker?.kyc_information?.full_address}}</span></div>
              <div class="key-val-row"><span class="key">SDT:</span><span class="value">{{contractDetail.contract?.seller_broker?.phone_number}}</span></div>
              <div class="key-val-row"><span class="key">Email:</span><span class="value">{{contractDetail.contract?.seller_broker?.email}}</span></div>
              <div class="key-val-row"><span class="key">Mã số thuế:</span><span class="value">{{contractDetail.contract?.seller_broker?.broker_profile?.tax_id}}</span></div>
              <div class="key-val-row"><span class="key">Ngân hàng:</span><span class="value">
                {{contractDetail.contract?.seller_broker?.broker_profile?.bank_info}}
              </span></div>
            </div>
            <div class="detail-btn" @click="handleShowDetail"><Icon icon="bi:info-circle-fill" /> chi tiết</div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Khách mua</th>
        <td>
          <div class="contract-ref-panel" v-if="contractDetail.contract?.buyer">
            <div class="subject">{{contractDetail.contract?.buyer?.full_name}}</div>
            <div class="desc">
              <div class="key-val-row"><span class="key">CCCD:</span><span class="value">{{contractDetail.contract?.buyer?.kyc_information?.national_id_number}}</span></div>
              <div class="key-val-row"><span class="key">Địa chỉ:</span><span class="value">{{contractDetail.contract?.buyer?.kyc_information?.full_address}}</span></div>
              <div class="key-val-row"><span class="key">SDT:</span><span class="value">{{contractDetail.contract?.buyer?.phone_number}}</span></div>
              <div class="key-val-row"><span class="key">Email:</span><span class="value">{{contractDetail.contract?.buyer?.email}}</span></div>
              <div class="key-val-row"><span class="key">Mã số thuế:</span><span class="value">{{contractDetail.contract?.buyer?.broker_profile?.tax_id}}</span></div>
              <div class="key-val-row"><span class="key">Ngân hàng:</span><span class="value">
                {{contractDetail.contract?.buyer?.broker_profile?.bank_info}}
              </span></div>
            </div>
            <div class="detail-btn" @click="handleShowDetail"><Icon icon="bi:info-circle-fill" /> chi tiết</div>
          </div>
          <template v-else>--</template>
        </td>
        <th class="text-right w-[150px]">Môi giới mua</th>
        <td>
          <div class="contract-ref-panel" v-if="contractDetail.contract?.buyer_broker">
            <div class="subject">{{contractDetail.contract?.buyer_broker?.full_name}}</div>
            <div class="desc">
              <div class="key-val-row"><span class="key">CCCD:</span><span class="value">{{contractDetail.contract?.buyer_broker?.kyc_information?.national_id_number}}</span></div>
              <div class="key-val-row"><span class="key">Địa chỉ:</span><span class="value">{{contractDetail.contract?.buyer_broker?.kyc_information?.full_address}}</span></div>
              <div class="key-val-row"><span class="key">SDT:</span><span class="value">{{contractDetail.contract?.buyer_broker?.phone_number}}</span></div>
              <div class="key-val-row"><span class="key">Email:</span><span class="value">{{contractDetail.contract?.buyer_broker?.email}}</span></div>
              <div class="key-val-row"><span class="key">Mã số thuế:</span><span class="value">{{contractDetail.contract?.buyer_broker?.broker_profile?.tax_id}}</span></div>
              <div class="key-val-row"><span class="key">Ngân hàng:</span><span class="value">
                {{contractDetail.contract?.buyer_broker?.broker_profile?.bank_info}}
              </span></div>
            </div>
            <div class="detail-btn" @click="handleShowDetail"><Icon icon="bi:info-circle-fill" /> chi tiết</div>
          </div>
          <template v-else>--</template>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table text-[11px]">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Giá trị hợp đồng (A)</th>
        <td>
          <money-amount :amount="contractDetail.contract.contract_deal_amount"/>
        </td>
        <th class="text-right w-[150px]">Hoa hồng môi giới (B)</th>
        <td>
          <commission-amount :percent="contractDetail.contract.commission_percent*100" :amount="contractDetail.contract.commission_amount"/>
          <Divider/>
          <div class="flex flex-col md:flex-row w-full">
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng công ty (C = B x <percent-amount :percent="contractDetail.contract.company_commission_percent * 100"/>)</div>
              <div>
                <commission-amount :percent="(contractDetail.contract.commission_percent * contractDetail.contract.company_commission_percent)*100" :amount="contractDetail.contract.company_commission_amount"/>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng hệ thống (D = B x <percent-amount :percent="contractDetail.contract.network_commission_percent * 100"/>)</div>
              <div>
                <commission-amount :percent="(contractDetail.contract.commission_percent * contractDetail.contract.network_commission_percent)*100" :amount="contractDetail.contract.network_commission_amount"/>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng môi giới bán (E = B x <percent-amount :percent="contractDetail.contract.seller_broker_percent * 100"/>)</div>
              <div>
                <commission-amount :percent="(contractDetail.contract.commission_percent * contractDetail.contract.seller_broker_percent)*100" :amount="contractDetail.contract.seller_broker_amount"/>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng môi giới mua (F = B x <percent-amount :percent="contractDetail.contract.buyer_broker_percent * 100"/>)</div>
              <div>
                <commission-amount :percent="(contractDetail.contract.commission_percent * contractDetail.contract.buyer_broker_percent)*100" :amount="contractDetail.contract.buyer_broker_amount"/>
              </div>
            </div>
          </div>

        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="py-3 flex flex-col gap-5" v-else>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Loại hợp đồng</th>
        <td colspan="3">
          <div class="flex-1 font-bold uppercase">
            <Skeleton width="15rem" height="1rem"></Skeleton>
          </div>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Mã hợp đồng</th>
        <td colspan="3">
          <Skeleton width="10rem" height="1rem"></Skeleton>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiêu đề hợp đồng</th>
        <td colspan="3">
          <Skeleton width="30rem" height="1.2rem" class="mb-3"></Skeleton>
          <Skeleton width="50rem" height="1rem"></Skeleton>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Đính kèm</th>
        <td colspan="3">
          <Skeleton width="10rem" height="1rem" class="mb-2"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-2"></Skeleton>
          <Skeleton width="15rem" height="1rem" class="mb-2"></Skeleton>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Ngày ký</th>
        <td>
          <Skeleton width="10rem" height="1rem"></Skeleton>
        </td>
        <th class="text-right w-[150px]">Ngày thanh lý</th>
        <td>
          <Skeleton width="10rem" height="1rem"></Skeleton>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiến độ hợp đồng</th>
        <td colspan="3">
          <Skeleton height="4rem"></Skeleton>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Chính chủ</th>
        <td>
          <Skeleton width="10rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
        </td>
        <th class="text-right w-[150px]">Môi giới bán</th>
        <td>
          <Skeleton width="10rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Khách mua</th>
        <td>
          <Skeleton width="10rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
        </td>
        <th class="text-right w-[150px]">Môi giới mua</th>
        <td>
          <Skeleton width="10rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
          <Skeleton width="20rem" height="1rem" class="mb-3"></Skeleton>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Giá trị hợp đồng (A)</th>
        <td>
          <Skeleton width="10rem" height="1rem"></Skeleton>
        </td>
        <th class="text-right w-[150px]">Hoa hồng môi giới (B)</th>
        <td>
          <Skeleton width="10rem" height="1rem"></Skeleton>
          <Divider/>
          <div class="flex flex-col md:flex-row w-full">
            <div class="flex flex-1 flex-col">
              <Skeleton width="10rem" height="1rem"></Skeleton>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <Skeleton width="10rem" height="1rem"></Skeleton>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <Skeleton width="10rem" height="1rem"></Skeleton>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <Skeleton width="10rem" height="1rem"></Skeleton>
            </div>
          </div>

        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
